import { useQuery } from '@tanstack/react-query';
import req from 'utils/req';
import { z } from 'zod';

const HostProfilesResponseSchema = z.array(
  z.object({
    id: z.string().uuid(),
    hostIsLicensed: z.boolean(),
    hostIsCompany: z.boolean(),
    profilePicture: z.string().url(),
  }),
);

const fetchHostProfiles = async (hostIds: string[]) => {
  const searchParams = new URLSearchParams();
  hostIds.forEach((hostId) => searchParams.append('id', hostId));

  const response = await req(
    `${URL_API_HOST}/api/v1/portfolio/host/profiles?${searchParams.toString()}`,
  ).get();

  const result = HostProfilesResponseSchema.safeParse(response);
  if (!result.success) {
    console.error('Failed to fetch host profiles', result.error);
    return [];
  }

  return result.data;
};

export const useHostProfiles = (hostIds: string[]) => {
  return useQuery({
    queryKey: ['hostProfiles', ...hostIds],
    queryFn: () => fetchHostProfiles(hostIds),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: 0,
  });
};

export default useHostProfiles;
